export default __webpack_public_path__ + "static/media/Group-103.242947e8.png";